import { render, staticRenderFns } from "./EventDispatcher.vue?vue&type=template&id=38634fc4&"
import script from "./EventDispatcher.vue?vue&type=script&lang=js&"
export * from "./EventDispatcher.vue?vue&type=script&lang=js&"
import style0 from "./EventDispatcher.vue?vue&type=style&index=0&id=38634fc4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports